import { Component, Inject } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SystemNotice } from '../../../../../services/system-notice.service';
import { RtI18nDirective } from '../../runtime-translation.directive';

export interface SystemNoticePopupDialogData {
  notice: SystemNotice;
  onMoreInfo: () => void;
}

/**
 * Modal presentation of a notice (SystemNoticeTypeEnum.Popup) - image, title and description.
 * Every close path records the dismissal, so the caller handles that in afterClosed().
 */
@Component({
  standalone: true,
  selector: 'system-notice-popup',
  templateUrl: './system-notice-popup.component.html',
  styleUrl: './system-notice-popup.component.scss',
  imports: [MatDialogModule, RtI18nDirective]
})
export class SystemNoticePopupComponent {

  public imageFailed = false;

  constructor(
    private dialogRef: MatDialogRef<SystemNoticePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SystemNoticePopupDialogData
  ) { }

  public get imageUrl(): string | undefined {
    return this.data.notice.SecureImageUrl ?? this.data.notice.Image;
  }

  public close(): void {
    this.dialogRef.close();
  }
}
